import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '../store';

export const apis = createApi({
  reducerPath: 'apis',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders(headers, { getState }) {
      const { token } = (getState() as RootState).auth;
      headers.set('Authorization', `bearer ${token}`);
      headers.set('Cache-Control', 'no-cache');
      return headers;
    },
  }),
  tagTypes: ['Lottery', 'ManualParticipants'],
  endpoints: () => ({}),
});
